// extracted by mini-css-extract-plugin
export default {"header":"Analyse-module_header__3yR3D","resultsContainer":"Analyse-module_resultsContainer__2-P2K","seeMore":"Analyse-module_seeMore__1_zqp"};